import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { HttpService } from 'src/app/services/http.service';
import { Subject, Observable } from 'rxjs';
import { tap, catchError, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class JioTvPlanservice {
    private authData: any;
    private jiotvPlansSubject = new Subject();

    jiotvplans$: Observable<any> = this.jiotvPlansSubject.asObservable();

    constructor(private auth: AuthService, private http: HttpService) {
        this.authData = this.auth.getAuthData();
    }
    getServicesData(pageNo: any = '') {
        const url = `${environment.apiUrlDomain}/ottservices?pageNo=${pageNo}&sort=-updatedTime -status`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.jiotvPlansSubject.next({
                            type: 'SERVICES_DATA_GET_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                }),
                catchError((error: any) => {
                    this.jiotvPlansSubject.next({
                        type: 'SERVICES_DATA_GET_FAILED',
                        data: error,
                    });
                    throw Error;
                })
            )
            .subscribe();
    }

    getServicesBySearch(searchKey: string = '', status: any, pageNo: any = '') {
        let url = `${environment.apiUrlDomain}/ottservices`;

        const queryParams = [];

        if (searchKey) {
            queryParams.push(`any=${searchKey}`);
        }

        if (status || status === 0) {
            queryParams.push(`status=${status}`);
        }

        if (pageNo) {
            queryParams.push(`pageNo=${pageNo}`);
        }

        if (queryParams.length > 0) {
            url += `?${queryParams.join('&')}`;
        }

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    console.log('search services Data:', response);
                    this.jiotvPlansSubject.next({
                        type: 'SERVICES_SEARCH_GET_SUCCESSFUL',
                        data: response.body,
                    });
                }),
                catchError((error: any) => {
                    this.jiotvPlansSubject.next({
                        type: 'SERVICES_SEARCH_GET_FAILED',
                        data: error,
                    });
                    throw Error;
                })
            )
            .subscribe();
    }

    createServicesData(name: string, origin: string) {
        const url = `${environment.apiUrlDomain}/ottservices`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        const data: any = {
            name: name,
            origin: origin,
        };

        this.http
            .postRequest(url, headers, data)
            .pipe(
                tap((response: any) => {
                    console.log('services created', response);
                    if (response.status == 201) {
                        this.jiotvPlansSubject.next({
                            type: 'SERVICES_DATA_CREATE_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                }),
                catchError((error: any) => {
                    this.jiotvPlansSubject.next({
                        type: 'SERVICES_DATA_CREATE_FAILED',
                        data: error,
                    });
                    throw Error;
                })
            )
            .subscribe();
    }

    getOriginData() {
        const url = `${environment.apiUrlDomain}/subscription/populate/dropdown?type=planOrigins&op=create`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.jiotvPlansSubject.next({
                            type: 'ORIGIN_DROPDOWN_GET_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                    // console.log(response);
                }),
                catchError((error: any) => {
                    this.jiotvPlansSubject.next({
                        type: 'ORIGIN_DROPDOWN_GET_FAILED',
                        data: error,
                    });
                    throw error;
                })
            )
            .subscribe();
    }

    getServicesDatabyId(id: string) {
        const url = `${environment.apiUrlDomain}/ottservices/${id}`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    console.log('Services data:', response);
                    if (response.status == 200) {
                        this.jiotvPlansSubject.next({
                            type: 'SERVICES_DATA_ID_GET_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                    console.log('SERVICES_DATA_ID_GET_SUCCESSFUL', response.body);
                }),
                catchError((error: any) => {
                    this.jiotvPlansSubject.next({
                        type: 'SERVICES_DATA_ID_GET_FAILED',
                        data: error,
                    });
                    throw Error;
                })
            )
            .subscribe();
    }

    updateServicesData(id: string, name: string) {
        const url = `${environment.apiUrlDomain}/ottservices/${id}`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        const data: any = {
            name: name,
        };

        this.http
            .putRequest(url, headers, data)
            .pipe(
                tap((response: any) => {
                    console.log('services updated', response);
                    if (response.status == 200) {
                        this.jiotvPlansSubject.next({
                            type: 'SERVICES_DATA_UPDATE_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                }),
                catchError((error: any) => {
                    this.jiotvPlansSubject.next({
                        type: 'SERVICES_DATA_UPDATE_FAILED',
                        data: error,
                    });
                    throw Error;
                })
            )
            .subscribe();
    }
    getPlansData(pageNo: any = '') {
        const url = `${environment.apiUrlDomain}/subscription?pageNo=${pageNo}&sort=-status -updatedTime`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.jiotvPlansSubject.next({
                            type: 'PLANS_DATA_GET_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                }),
                catchError((error: any) => {
                    this.jiotvPlansSubject.next({
                        type: 'PLANS_DATA_GET_FAILED',
                        data: error,
                    });
                    throw Error;
                })
            )
            .subscribe();
    }

    getPlansBySearch(searchKey: string = '', planType: any = '', planOrigin: any = '', status: any, pageNo: any = '') {
        let url = `${environment.apiUrlDomain}/subscription?sort=-status -updatedTime`;

        const queryParams = [];

        if (searchKey) {
            queryParams.push(`any=${searchKey}`);
        }
        if (planType) {
            queryParams.push(`planType=${planType}`);
        }
        if (planOrigin) {
            queryParams.push(`planOrigin=${planOrigin}`);
        }

        if (status || status === 0) {
            queryParams.push(`status=${status}`);
        }

        if (pageNo) {
            queryParams.push(`pageNo=${pageNo}`);
        }

        if (queryParams.length > 0) {
            url += `&${queryParams.join('&')}`;
        }

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    console.log('search services Data:', response);
                    this.jiotvPlansSubject.next({
                        type: 'PLANS_SEARCH_GET_SUCCESSFUL',
                        data: response.body,
                    });
                }),
                catchError((error: any) => {
                    this.jiotvPlansSubject.next({
                        type: 'PLANS_SEARCH_GET_FAILED',
                        data: error,
                    });
                    throw Error;
                })
            )
            .subscribe();
    }

    getPlansTypeData() {
        const url = `${environment.apiUrlDomain}/subscription/populate/dropdown?type=planTypes`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.jiotvPlansSubject.next({
                            type: 'PLAN_TYPE_DROPDOWN_GET_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                }),
                catchError((error: any) => {
                    this.jiotvPlansSubject.next({
                        type: 'PLAN_TYPE_DROPDOWN_GET_FAILED',
                        data: error,
                    });
                    throw Error;
                })
            )
            .subscribe();
    }

    getPlansOriginData(op: string = 'update') {
        const url = `${environment.apiUrlDomain}/subscription/populate/dropdown?type=planOrigins&op=${op}`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.jiotvPlansSubject.next({
                            type: 'PLAN_ORIGIN_DROPDOWN_GET_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                }),
                catchError((error: any) => {
                    this.jiotvPlansSubject.next({
                        type: 'PLAN_ORIGIN_DROPDOWN_GET_SUCCESSFUL',
                        data: error,
                    });
                    throw Error;
                })
            )
            .subscribe();
    }

    getBillingFrequencyId() {
        const url = `${environment.apiUrlDomain}/service/master-config?key=billingFrequencies`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.jiotvPlansSubject.next({
                            type: 'BILLING_DROPDOWN_GET_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                    // console.log(response);
                }),
                catchError((error: any) => {
                    this.jiotvPlansSubject.next({
                        type: 'BILLING_DROPDOWN_GET_FAILED',
                        data: error,
                    });
                    throw error;
                })
            )
            .subscribe();
    }

    getProductData() {
        const url = `${environment.apiUrlDomain}/service/master-config?key=chargeitProducts`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.jiotvPlansSubject.next({
                            type: 'PRODUCT_DROPDOWN_GET_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                    // console.log(response);
                }),
                catchError((error: any) => {
                    this.jiotvPlansSubject.next({
                        type: 'PRODUCT_DROPDOWN_GET_FAILED',
                        data: error,
                    });
                    throw error;
                })
            )
            .subscribe();
    }

    getBusinessTypeData() {
        const url = `${environment.apiUrlDomain}/subscription/populate/dropdown?type=operators`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.jiotvPlansSubject.next({
                            type: 'BUSINESS_DROPDOWN_GET_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                    // console.log(response);
                }),
                catchError((error: any) => {
                    this.jiotvPlansSubject.next({
                        type: 'BUSINESS_DROPDOWN_GET_FAILED',
                        data: error,
                    });
                    throw error;
                })
            )
            .subscribe();
    }

    createPlans(
        name: string,
        description: string,
        planType: string,
        planOrigin: string,
        price: number,
        discountedPrice: number,
        unit: string,
        value: number,
        billingFrequencyId: string,
        productId: string,
        status: number,
        applyDiscountOnce: boolean,
        businessType: any,
        isHidden: number,
        chargeitConfig?: {
            billingFrequencyId?: string;
            productId?: string;
            applyDiscountOnce?: boolean;
            discountRules?: Array<{
                condition: Array<{ fact: string; operator: string; value: number }>;
                event: { type: string; params: { discountValue: number } };
                status?: string;
                expirationDate?: string;
            }>;
        }
    ) {
        const url = `${environment.apiUrlDomain}/subscription`;

        const expiryTimeObj =
            !unit || unit.trim() === '' || value === null || value === undefined
                ? null
                : {
                      value: value,
                      unit: unit,
                  };

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        const chargeitPayload = chargeitConfig ?? {
            ...(billingFrequencyId && { billingFrequencyId }),
            ...(productId && { productId }),
        };

        const data: any = {
            ...(name && { name }),
            ...(description && { description }),
            ...(planType && { planType }),
            ...(planOrigin && { planOrigin }),
            ...(price && { price }),
            ...(discountedPrice && { discountedPrice }),
            expiryTime: expiryTimeObj,
            chargeitConfig: chargeitPayload,
            status: status,
            userType: businessType,
            applyDiscountOnce: applyDiscountOnce,
            isHidden: isHidden,
        };

        console.log('my data is here', data);

        this.http
            .postRequest(url, headers, data)
            .pipe(
                tap((response: any) => {
                    if (response.status == 201) {
                        this.jiotvPlansSubject.next({
                            type: 'PLANS_DATA_CREATE_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                }),
                catchError((error: any) => {
                    this.jiotvPlansSubject.next({
                        type: 'PLANS_DATA_CREATE_FAILED',
                        data: error,
                    });
                    throw error;
                })
            )
            .subscribe();
    }

    getPlansDataById(id: any) {
        const url = `${environment.apiUrlDomain}/subscription/${id}`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.jiotvPlansSubject.next({
                            type: 'PLANS_ID_GET_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                }),
                catchError((error) => {
                    this.jiotvPlansSubject.next({
                        type: 'PLANS_ID_GET_FAILED',
                        data: error,
                    });
                    throw error;
                }),
                shareReplay()
            )
            .subscribe();
    }
    getPlansDataByIdList(id: any) {
        const url = `${environment.apiUrlDomain}/subscription/${id}?op=list`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.jiotvPlansSubject.next({
                            type: 'PLANS_LIST_ID_GET_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                }),
                catchError((error) => {
                    this.jiotvPlansSubject.next({
                        type: 'PLANS_LIST_ID_GET_FAILED',
                        data: error,
                    });
                    throw error;
                }),
                shareReplay()
            )
            .subscribe();
    }

    updatePlans(
        id: any,
        name: string,
        description: string,
        planType: string,
        planOrigin: string,
        price: number,
        discountedPrice: number,
        unit: string,
        value: number,
        billingFrequencyId: string,
        productId: string,
        status: number,
        applyDiscountOnce: boolean,
        businessType: any,
        isHidden: number,
        chargeitConfig?: {
            billingFrequencyId?: string;
            productId?: string;
            applyDiscountOnce?: boolean;
            deactivateAfter?: string;
            discountLogicContinuity?: 'continue' | 'discontinue';
            discountRules?: Array<{
                condition: Array<{ fact: string; operator: string; value: number }>;
                event: { type: string; params: { discountValue: number } };
                status?: string;
                expirationDate?: string;
            }>;
        }
    ) {
        const url = `${environment.apiUrlDomain}/subscription/${id}`;

        const expiryTimeObj =
            !unit || unit.trim() === '' || value === null || value === undefined
                ? null
                : {
                      value: value,
                      unit: unit,
                  };

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        const chargeitPayload = chargeitConfig ?? {
            ...(billingFrequencyId && { billingFrequencyId }),
            ...(productId && { productId }),
        };

        const data: any = {
            ...(name && { name }),
            ...(description && { description }),
            ...(planType && { planType }),
            ...(planOrigin && { planOrigin }),
            ...(price && { price }),
            ...(discountedPrice && { discountedPrice }),
            expiryTime: expiryTimeObj,
            ...(planOrigin !== 'EPC' && { chargeitConfig: chargeitPayload }),
            status: status,
            userType: businessType,
            applyDiscountOnce: applyDiscountOnce,
            isHidden: isHidden,
        };

        console.log('my data is here', data);

        this.http
            .putRequest(url, headers, data)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.jiotvPlansSubject.next({
                            type: 'PLANS_DATA_UPDATE_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                }),
                catchError((error: any) => {
                    this.jiotvPlansSubject.next({
                        type: 'PLANS_DATA_UPDATE_FAILED',
                        data: error,
                    });
                    throw error;
                })
            )
            .subscribe();
    }

    getOTTListData(pageNo: any) {
        let url = `${environment.apiUrlDomain}/ottservices`;

        const queryParams = [];

        if (pageNo) {
            queryParams.push(`pageNo=${pageNo}`);
        }

        if (queryParams.length > 0) {
            url += `?${queryParams.join('&')}`;
        }

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.jiotvPlansSubject.next({
                            type: 'OTT_LIST_GET_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                    // console.log(response);
                }),
                catchError((error: any) => {
                    this.jiotvPlansSubject.next({
                        type: 'OTT_LIST_GET_FAILED',
                        data: error,
                    });
                    throw error;
                })
            )
            .subscribe();
    }

    private shouldIncludeBusinessType(userType: any): boolean {
        if (userType == null || userType === undefined) return false;
        const normalized = String(userType)
            .toUpperCase()
            .replace(/\s/g, '')
            .split(',')
            .map((p: string) => p.trim())
            .filter(Boolean);
        const hasJio = normalized.includes('JIO');
        const hasNonJio = normalized.includes('NON-JIO') || normalized.includes('NONJIO');
        return (normalized.length === 1 && hasJio) || (normalized.length === 2 && hasJio && hasNonJio);
    }

    getChannelListData(planType: any, pageNo: any, userType?: any) {
        const includeBusinessType = this.shouldIncludeBusinessType(userType);
        let url = `${environment.apiUrlDomain}/channels?status=1&planType=premium${
            includeBusinessType ? '&businessType=premium' : ''
        }&projection=name%20srno%20planType%20businessType%20status`;

        const queryParams = [];

        if (pageNo) {
            queryParams.push(`pageNo=${pageNo}`);
        }

        if (queryParams.length > 0) {
            url += `&${queryParams.join('&')}`;
        }

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.jiotvPlansSubject.next({
                            type: 'CHANNEL_LIST_GET_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                }),
                catchError((error: any) => {
                    this.jiotvPlansSubject.next({
                        type: 'CHANNEL_LIST_GET_FAILED',
                        data: error,
                    });
                    throw error;
                })
            )
            .subscribe();
    }

    getPlansContentData(id: any) {
        const url = `${environment.apiUrlDomain}/subscription/${id}/items`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.jiotvPlansSubject.next({
                            type: 'PLANS_CONTENT_DATA_GET_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                }),
                catchError((error: any) => {
                    this.jiotvPlansSubject.next({
                        type: 'PLANS_CONTENT_DATA_GET_FAILED',
                        data: error,
                    });
                    throw error;
                })
            )
            .subscribe();
    }

    updatePlansListData(id: string, items: any) {
        const url = `${environment.apiUrlDomain}/subscription/${id}/items`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        const data = {
            items,
        };

        this.http
            .postRequest(url, headers, items)
            .pipe(
                tap((response: any) => {
                    if (response.status == 201) {
                        this.jiotvPlansSubject.next({
                            type: 'PLANS_LIST_UPDATE_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                }),
                catchError((error) => {
                    this.jiotvPlansSubject.next({
                        type: 'PLANS_LIST_UPDATE_FAILED',
                        data: error,
                    });
                    throw error;
                }),
                shareReplay()
            )
            .subscribe();
    }

    getSearchedOTTListdata(searchKey: any, pageNo: any) {
        console.log('searchkay:any', searchKey);

        let url = `${environment.apiUrlDomain}/ottservices`;
        const queryParams = [];

        if (searchKey) {
            queryParams.push(`any=${searchKey}`);
        }
        queryParams.push(`pageNo=${pageNo}`);

        if (queryParams.length > 0) {
            url += `?${queryParams.join('&')}`;
        }

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };
        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.jiotvPlansSubject.next({
                            type: 'PLANS_OTT_LIST_SEARCH_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                }),
                catchError((error) => {
                    this.jiotvPlansSubject.next({
                        type: 'PLANS_OTT_LIST_SEARCH_FAILED',
                        data: error,
                    });
                    throw error;
                }),
                shareReplay()
            )
            .subscribe();
    }

    getSearchedChannelsListdata(
        planType: any,
        searchKey: any,
        language: any,
        broadcaster: any,
        pageNo: any,
        userType?: any
    ) {
        console.log('searchkay:any', searchKey, pageNo);

        const includeBusinessType = this.shouldIncludeBusinessType(userType);
        let url = `${environment.apiUrlDomain}/channels?status=1&planType=premium${
            includeBusinessType ? '&businessType=premium' : ''
        }&projection=name%20srno%20planType%20businessType%20status`;
        const queryParams = [];

        if (searchKey) {
            queryParams.push(`any=${searchKey}`);
        }
        if (language) {
            queryParams.push(`languageId=${language}`);
        }
        if (broadcaster) {
            queryParams.push(`broadcasterId=${broadcaster}`);
        }
        if (pageNo) {
            queryParams.push(`pageNo=${pageNo}`);
        }

        if (queryParams.length > 0) {
            url += `&${queryParams.join('&')}`;
        }

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };
        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.jiotvPlansSubject.next({
                            type: 'PLANS_CHANNELS_LIST_SEARCH_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                }),
                catchError((error) => {
                    this.jiotvPlansSubject.next({
                        type: 'PLANS_CHANNELS_LIST_SEARCH_FAILED',
                        data: error,
                    });
                    throw error;
                }),
                shareReplay()
            )
            .subscribe();
    }
    deleteServicesData(id: any) {
        const url = `${environment.apiUrlDomain}/ottservices/${id}`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .deleteRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    console.log('delete Plans Data:', response);
                    this.jiotvPlansSubject.next({
                        type: 'SERVICES_DELETE_SUCCESSFUL',
                        data: response.body,
                    });
                }),
                catchError((error: any) => {
                    this.jiotvPlansSubject.next({
                        type: 'SERVICES_DELETE_FAILED',
                        data: error,
                    });
                    throw Error;
                })
            )
            .subscribe();
    }

    getMasterCollectionData() {
        const url = `${environment.apiUrlDomain}/mastercollectiondata?collections=broadcasters%2Clanguages`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    console.log('mastercollectiondata:', response);
                    this.jiotvPlansSubject.next({
                        type: 'MASTER_COLLECTION_GET_SUCCESSFUL',
                        data: response.body,
                    });
                }),
                catchError((error: any) => {
                    this.jiotvPlansSubject.next({
                        type: 'MASTER_COLLECTION_GET_FAILED',
                        data: error,
                    });
                    throw Error;
                })
            )
            .subscribe();
    }

    getServicesDropdownData() {
        const url = `${environment.apiUrlDomain}/ottservices?pageSize=10000`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    console.log('mastercollectiondata:', response);
                    this.jiotvPlansSubject.next({
                        type: 'SERVICES_DROPDOWN_GET_SUCCESSFUL',
                        data: response.body,
                    });
                }),
                catchError((error: any) => {
                    this.jiotvPlansSubject.next({
                        type: 'SERVICES_DROPDOWN_GET_FAILED',
                        data: error,
                    });
                    throw Error;
                })
            )
            .subscribe();
    }

    getAllChargeItDropdownData() {
        const url = `${environment.apiUrlDomain}/service/master-config?key=chargeitDiscountConfig`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    console.log('mastercollectiondata:', response);
                    this.jiotvPlansSubject.next({
                        type: 'CHARGEIT_DROPDOWN_GET_SUCCESSFUL',
                        data: response.body,
                    });
                }),
                catchError((error: any) => {
                    this.jiotvPlansSubject.next({
                        type: 'CHARGEIT_DROPDOWN_GET_FAILED',
                        data: error,
                    });
                    throw Error;
                })
            )
            .subscribe();
    }
}
